/**
 * The links inside a description or a comment.
 *
 * Two sentences, and both answer the same question: where does this go? A link that opens a page of
 * this app carries Visious's mark, one that leaves carries the mark of the site it leaves for, and
 * these are the words that go with each. A link to a site the app does not recognise says nothing
 * extra: it keeps its full address and behaves the way a link in a paragraph has always behaved.
 */
export const richText = {
  /** On a link that opens a page of this app: a video, a channel, a playlist, a search. */
  opensHere: 'Opens in Visious.',
  /**
   * On a link that leaves for a site the app knows the mark of. `site` is that site's own name, which
   * is the same word in every language.
   */
  opensOn: (site: string) => `Opens on ${site}.`,
} as const;
